import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { APPLICATION_ROUTES } from '../constants/application-routes';

@Injectable({
    providedIn: 'root',
})
export class TechnicalDifficultiesRedirectGuard implements CanActivate {
    private router = inject(Router);


    canActivate(): boolean {
        this.router.navigate([APPLICATION_ROUTES.TECHNICAL_DIFFICULTIES], {
            state: { internal: true },
        });
        return false;
    }
}
